import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import { media } from '../../ui-components/styles/media';
import { colors } from '../styles';
import renderRichText from '../../utils/render-rich-text';
import { Text } from './text';

const propTypes = {
  stat: PropTypes.string.isRequired,
  statContent: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  largeMobileStat: PropTypes.bool
};

/**
 * Renders a statistic
 *
 * @prop {bool} largeMobileStat - if the statistic should stay the same size in mobile view
 * @returns
 */
const Statistic = props => {
  const { stat, statContent, largeMobileStat = false } = props;

  return (
    <StatWrapper>
      <StatHeading largeMobileStat={+largeMobileStat}>{stat}</StatHeading>
      &nbsp;
      <Text size={'large'}>{statContent?.raw ? renderRichText(statContent) : statContent}</Text>
    </StatWrapper>
  );
};

const StatWrapper = styled.div`
  * {
    display: inline;
  }
`;

const StatHeading = styled.span`
  color: ${colors.crederaRed};
  font-family: Tiempos Headline;
  font-style: normal;
  font-weight: 500;
  font-size: 36px;
  line-height: 48px;
  /* margin-right: 6px; */

  @media (max-width: ${media.smallTop}) {
    font-size: ${({ largeMobileStat }) => (largeMobileStat ? '' : '22px')};
    line-height: ${({ largeMobileStat }) => (largeMobileStat ? '' : '32px')};
  }
`;

Statistic.propTypes = propTypes;

export default Statistic;
